export default __webpack_public_path__ + "static/media/event-management-logistics-services.4cc22fa3.svg";